import _ from '../../utils/_';
import './breadcrumb.scss';

const Breadcrumb = ({items, className}) => {
  return (
    <div className={'app-breadcrumb' + (className ? ` ${className}` : '')}>
      <div className="container">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            {_.init(items).map((x, i) => (
              <li key={_.toString(i)} className="breadcrumb-item">
                <a href={x.url}>{x.name}</a>
              </li>
            ))}
            {
              <li className="breadcrumb-item active" aria-current="page">
                {_.last(items).name}
              </li>
            }
          </ol>
        </nav>
      </div>
    </div>
  );
};

export default Breadcrumb;
